var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-source" },
    [
      _vm.getIsTizen
        ? _c("object", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player", type: "application/avplayer" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getIsLG && _vm.getLGVersion >= "5.0"
        ? _c("object", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getLGVersion < "5.0"
        ? _c("video", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getIsOrsay
        ? _c("object", {
            staticClass: "tv-player__video",
            attrs: { id: "av-player", type: "application/avplayer" }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.getIsOrsay && !_vm.getIsLG && !_vm.getIsTizen
        ? _c("video", {
            staticClass: "tv-player__video",
            attrs: {
              src: "https://media.digmedia.net/website/video/rain_264.mp4?_=1",
              muted: "",
              autoplay: "",
              loop: ""
            },
            domProps: { muted: true }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: _vm.selectionMode ? "fade" : "" } }, [
        _vm.showOSD
          ? _c("div", { staticClass: "input-source__osd" }, [
              _c("div", { staticClass: "osd__header" }, [
                _c(
                  "div",
                  {
                    staticClass: "osd-back",
                    class: { "osd-back--active": _vm.backButtonSelected }
                  },
                  [
                    _c(
                      "Icon",
                      { attrs: { color: "#f1f1f1" } },
                      [_c("ArrowLeft")],
                      1
                    ),
                    _vm._v(" " + _vm._s(_vm.getBack) + "\n        ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tv-osd__header-title" },
                  [
                    !_vm.selectionMode
                      ? [_vm._v(_vm._s(_vm.source) + " " + _vm._s(_vm.port))]
                      : [_vm._v("HDMI Source Selection")]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _vm.selectionMode
                ? _c("div", { staticClass: "source-selection" }, [
                    _c(
                      "div",
                      { staticClass: "source-list" },
                      _vm._l(_vm.hdmiSources, function(source, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "source-item",
                            class: {
                              "source-item--active":
                                _vm.selectedSourceIndex === index &&
                                !_vm.backButtonSelected
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(source.name) +
                                "\n          "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "selection-instructions" })
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ea0281b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea0281b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SourceSelect.vue
// module id = null
// module chunks = 